module.exports = __webpack_public_path__ + "static/media/github.6cd12b48.svg";